import { useSelector } from "react-redux";
import { useEffect } from "react";
import { actionFetchTextMessageSources } from "@Store/actions/text_message_source.actions";

import { useAppDispatch, IReducerStore } from "@Store";

let initiated = false;

export const useTextMessageSources = (autoload: boolean = true) => {
  const dispatch = useAppDispatch();
  const text_message_sources = useSelector((store: IReducerStore) => {
    return store.text_message_source;
  });

  useEffect(() => {
    if (!initiated && autoload && !text_message_sources.loaded && !text_message_sources.loading) {
      initiated = true;
      dispatch(actionFetchTextMessageSources());
    }
  }, [autoload, text_message_sources.loaded, text_message_sources.loading, dispatch]);

  return text_message_sources;
};
